import { render, staticRenderFns } from "./TemplateDefault.vue?vue&type=template&id=520106ca&scoped=true"
import script from "./TemplateDefault.ts?vue&type=script&lang=ts&external"
export * from "./TemplateDefault.ts?vue&type=script&lang=ts&external"
import style0 from "./TemplateDefault.scss?vue&type=style&index=0&id=520106ca&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520106ca",
  null
  
)

export default component.exports